import { saveActivePropertyApi,
    getActiveValuePropertyList} from '@/api/api'

const state = {
    activePropertyList:[],
};
const getters = {
    getList:function (state) {
        return state.activePropertyList
    },
    getPro:function (state) {
        return state.productData
    },
    getProDetail:function (state) {
        return state.productDetail
    },
    getProductType:function (state) {
        return state.productType
    },
    getGroup:function (state) {
        return state.groupData
    },
    getGroupDetail:function (state) {
        return state.groupDetail
    },
};

const actions = {
    initPropertyList({commit,state},param){
        return new Promise((resolve) => {
            getActiveValuePropertyList(param).then((res) => {
                commit('INIT_PROPERTYLIST',res.data.value);
                resolve(res)
            })
        })
    }
};
let mutations = {
    INIT_PROPERTYLIST(state,param){
        state.activePropertyList = param
    },
}

export default {
    state,
    getters,
    actions,
    mutations,
}


// WEBPACK FOOTER //
// ./src/store/modules/activePropertyData.js